// Vistas de la página «Gastos» (Flujo → Gastos): la lista de gastos y
// «¿Cuándo se gastó?», que antes era una sección aparte (`/expenses/timeline`).

export const SPEND_VIEWS = ["list", "timeline"] as const;
export type SpendView = (typeof SPEND_VIEWS)[number];

/** Parámetro `?view=` de la URL; cualquier otro valor es la lista. */
export const spendViewOf = (value: string | null | undefined): SpendView => (value === "timeline" ? "timeline" : "list");
